<div class="app-layout">
  <app-sidebar [open]="sidebarOpen()" (closed)="closeSidebar()" />

  @if (sidebarOpen()) {
    <div class="sidebar-backdrop" (click)="closeSidebar()"></div>
  }

  <div class="main-area">
    <app-session-timeout />
    <app-topbar (menuToggle)="toggleSidebar()" />
    <main class="content">
      <router-outlet />
    </main>
  </div>
</div>
